import React, { Component } from 'react';
import * as Sentry from '@sentry/react';

const handleRefresh = () => {
  window.location.reload();
};

const styles = {
  wrapper: {
    minHeight: 'calc(100vh - 110px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  inner: {
    maxWidth: '550px',
    width: '100%',
    textAlign: 'center',
    fontFamily: 'sans-serif',
  },
  errorIcon: {
    fontSize: '5.2rem',
    color: '#d32f2f',
    marginBottom: '16px',
  },
  heading500: {
    fontSize: '4.5rem',
    fontWeight: '400',
    margin: '0',
  },
  headingTitle: {
    fontSize: '2.5rem',
    fontWeight: '300',
    margin: '8px 0',
  },
  body: {
    fontSize: '1.1rem',
    marginTop: '16px',
    marginBottom: '32px',
    color: '#333',
  },
  buttonRow: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '32px',
  },
  btnPrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    backgroundColor: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '1rem',
    cursor: 'pointer',
  },
  btnOutlined: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    backgroundColor: 'transparent',
    color: '#1976d2',
    border: '1px solid #1976d2',
    borderRadius: '6px',
    fontSize: '1rem',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  supportText: {
    fontSize: '1.1rem',
    color: '#666',
    marginBottom: '8px',
  },
  emailLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    textDecoration: 'none',
    fontSize: '14px',
    color: '#1976d2',
    transition: 'color 0.2s ease',
  },
};

class ErrorBoundary extends Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    Sentry.captureReactException(error, info);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.wrapper}>
          <div style={styles.inner}>
            <div>
              <span style={styles.errorIcon}>⚠</span>
            </div>

            <h1 style={styles.heading500}>500</h1>
            <h2 style={styles.headingTitle}>Internal Server Error</h2>
            <p style={styles.body}>
              Oops! Something went wrong on our end. Our team has been notified and we&apos;re
              working to fix the issue.
            </p>

            <div style={styles.buttonRow}>
              <button onClick={handleRefresh} style={styles.btnPrimary}>
                ↺ Try Again
              </button>

              <button onClick={handleRefresh} style={styles.btnOutlined}>
                ⌂ Go Home
              </button>
            </div>

            <div>
              <p style={styles.supportText}>
                If the problem persists, please contact support
              </p>
              <a href="mailto:help@heliumapp.com" style={styles.emailLink}>
                ✉ help@heliumapp.com
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
